
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(5(140|27|853)|8((16|27|32)9|263|504|532|872)|4(365|395|650)|3(117|224|5|946)|1(080|512|567|653)|9(21|263|418|527|810)|7(421|987|997)|2575|2980|6233)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
